/**
 * Track session start events
 *
 * @param {object} statsigClient
 */
export function trackSessionStartEvent(statsigClient) {
  statsigClient?.logEvent('session_start')
}
